import { translate } from '../../../../services/i18n';

import { StyledGradeContainer, StyledGrade, StyledGradeText } from './styles';

export const ContactGrade = ({ grade, onHover }: { grade: string; onHover?: () => void }) => (
  <StyledGradeContainer data-automation="ContactGrade" onMouseEnter={onHover}>
    <StyledGrade>{grade}</StyledGrade>
    <StyledGradeText>{translate('contact_card.confidence_grade')}</StyledGradeText>
  </StyledGradeContainer>
);
